<template lang="pug">
div
  SubHeader(apiname='news',headname='SWAN ニュース')
  .card
    .container-fluid
      h3.box-title SWAN ニュース一覧
      WorkList(apiname='news',editPath='edit')
      router-link(to='edit')
        el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import SubHeader from '@/views/components/swan/common/SubHeader'
import WorkList from '@/views/components/swan/common/List'

export default {
  name: 'Top',
  data () {
    return {
      tableData: [],
      request: []
    }
  },
  components: {
    SubHeader,
    WorkList
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card {
  padding: 16px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/news/list.vue